import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const RequireAdmin: React.FC<{ children: React.ReactElement }>=({ children })=>{
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh' }}>
        Yükleniyor...
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/giris?tab=admin" state={{ from: location }} replace />;
  }

  if ((currentUser as any).role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default RequireAdmin;
